import { enrollButtonClickEvent } from "@/lib/segment";
import enroll from "./enroll";
import getEnrollmentClickEventPayload from "./getEnrollmentClickEventPayload";
import { EnrollHandlerProps } from "../types";

const enrollmentHandler =
  ({
    courseRun,
    course,
    isUserEntitled,
    emailOptIn,
    type,
    opts = { directToPayment: false },
    commerceCoordinatorUrl,
    shouldHaveQueryParams,
    isUserEnrolledInRun,
    isLoggedIn,
    isMobile,
    searchParams,
    useNewTrackSelect,
    category,
    courseSlug,
    authBaseUrl,
    byPassAuth = false,
  }: EnrollHandlerProps) =>
  async () => {
    enrollButtonClickEvent(
      getEnrollmentClickEventPayload({
        courseRun,
        course,
        isUserEntitled,
        emailOptIn,
        shouldHaveQueryParams,
        isUserEnrolledInRun,
        isLoggedIn,
        isMobile,
        searchParams,
        byPassAuth,
      }),
    );
    await enroll({
      courseRun,
      course,
      isUserEntitled,
      emailOptIn,
      type,
      opts,
      commerceCoordinatorUrl,
      shouldHaveQueryParams,
      isUserEnrolledInRun,
      isLoggedIn,
      isMobile,
      searchParams,
      useNewTrackSelect,
      category,
      courseSlug,
      authBaseUrl,
      byPassAuth,
    });
  };

export default enrollmentHandler;
